import { render, staticRenderFns } from "./Info-detail.vue?vue&type=template&id=7bb95d98&"
import script from "./Info-detail.vue?vue&type=script&lang=js&"
export * from "./Info-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports